import angular from 'angular';
import component from './printTracking.component';
import Listing from '../listing/index';
import Tracking from 'cars-ng-tracking';

export default angular.module('printTracking', [
        Listing,
        Tracking
    ])
    .component('printTracking', component)
    .name;